// import React, { Fragment } from 'react'
// import { UncontrolledAlert } from 'reactstrap'
// import PropTypes from 'prop-types'
// import { alertClass } from '../helpers/helper'
// import successIcon from '../assests/images/notification-check.svg'
// import alertIcon from '../assests/images/notification-error.svg'

// function ToastMessage (props) {
//   const {
//     message,
//     modalMessage,
//     status,
//     close
//   } = props
//   return (
//     <Fragment>
//       {modalMessage && message && (
//         <UncontrolledAlert color="primary" className={alertClass(status, close)}>
//           <div className='success-toast-div'>
//             <div className={status ? 'success-box' : 'img-box'}>
//               <img src={status ? successIcon : alertIcon} alt='alert' className='alert-icon' width='20px' height="20px" />
//             </div>
//             <div className='message'>
//               <p className='m-0'>{message}</p>
//             </div>
//           </div>
//         </UncontrolledAlert>
//       )}
//     </Fragment>
//   )
// }
// ToastMessage.propTypes = {
//   message: PropTypes.string,
//   modalMessage: PropTypes.bool,
//   status: PropTypes.bool,
//   close: PropTypes.bool
// }
// export default ToastMessage

import React, { useEffect } from 'react'
import checkIcon from '../assests/images/notification-check.svg'
import wrongIcon from '../assests/images/notification-error.svg'
import PropTypes from 'prop-types'

function ToastMessage ({ isSuccess = false, isVisible = false, message, position = 'top-right', onToggle, displayTime = 5000, autoHide = true }) {
  useEffect(() => {
    let autoHideTimeout = null
    if (autoHide && isVisible) {
      autoHideTimeout = setTimeout(onToggle, displayTime)
    }
    return () => clearTimeout(autoHideTimeout)
  }, [isVisible])

  const notificationType = isSuccess ? 'n-success' : 'n-failure'
  return isVisible
    ? (
        <>
            <div className={`notification-container ${position}`}>
                <div className={`notification-toast toast-notification ${position} ${notificationType}`} >
                    <button onClick={onToggle}>X</button>
                    <div className="notification-image">
                        <img src={isSuccess ? checkIcon : wrongIcon} alt={isSuccess ? 'successIcon' : 'failureIcon'} />
                    </div>
                    <div>
                        <p className="notification-title">{isSuccess ? 'Success' : 'Failure'}</p>
                        <p className="notification-message">{message}</p>
                    </div>
                </div>
            </div>
        </>
      )
    : null
}
ToastMessage.propTypes = {
  isSuccess: PropTypes.bool,
  isVisible: PropTypes.bool,
  message: PropTypes.string,
  position: PropTypes.string,
  onToggle: PropTypes.any,
  displayTime: PropTypes.number,
  autoHide: PropTypes.bool

}
export default ToastMessage
